/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import { DropdownItem } from 'reactstrap';
import { SubsContext } from '../Billsby/SubscriptionInfo';
import { planFeatures } from '../Billsby/plans';

const LevelSelect = ({
  level,
  onSelect,
  path,
}) => {
  const { subscriptionLevel, setSubscriptionLevel } = useContext(SubsContext);
  const xLevel = level === "Undefined" ? "" : level;

  const setLevel = () => {
    setSubscriptionLevel(xLevel);
    onSelect();
  }

  const checked = () => (<span>{subscriptionLevel === xLevel && (<span>&#x2713;&nbsp;</span>)} {level}</span>)

  return (
    <div title={planFeatures[level].join("\n")}>
      <LinkContainer
        to={path}
        isActive={() => false}
      >
        <DropdownItem onClick={() => { setLevel() }}>
          {checked()}
        </DropdownItem>
      </LinkContainer>
    </div>
  )
}

LevelSelect.propTypes = {
  level: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
};

export default LevelSelect;




// WEBPACK FOOTER //
// ./src/components/Subscription/LevelSelect.jsx